import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { LoginService } from '../shared/services/login.service';
import { ServerStatusService } from '../shared/services/server-status.service';
import { CreateAccountService } from '../shared/services/create-account.service';
import { LoginValues } from '../shared/mock/login-values';
import { CustomerAccess, Login } from '../shared/types/login';
import { Credentials } from '../shared/types/credentials';
import { ModalComponent } from '../modal/modal.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { BlockUIService } from '../shared/components/block-ui/block-ui.service';
import { HttpClient } from '@angular/common/http';
import { CustomerLogin } from '../shared/types/customer-login';
import { SearchService } from 'app/shared/services/search.service';
import { LoginVerbiage } from 'app/shared/types/login-verbiage';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('forgotPass', { static: false }) public forgotPass: ModalComponent;
  @ViewChild('multipleAccounts', { static: false }) public multipleAccounts: ModalComponent;
  @ViewChild('childModal', { static: false }) public childModal: ModalComponent;
  @ViewChild('spinner', { static: false }) public spinner: SpinnerComponent;

  public ipAddress: any;
  public LoginTextValues: Login = LoginValues;
  public credentials: Credentials = {
    username: '',
    grant_type: 'password',
    password: ''
  };
  public loginForm: UntypedFormGroup;
  public messageLedge: any;
  public tableLedge: any;
  public radiusActive = true;
  public emptyUser = false;
  public emptyPass = false;
  public loginError = 'You must add a password.';
  public emailRequired = `*An Email is required.`;
  public emailError = '*Invalid email.';
  public userEmail = '';
  public email_sent: boolean;
  public sendEmail = new UntypedFormControl('', [Validators.required]);
  public multipleAccountForm = new UntypedFormControl('', [Validators.required]);
  public deviceInfo: any;
  public buttonStatus = true;
  public customerLedge: any;
  public total = 0;
  public websiteAnnouncement: string;
  public textMessage = '';
  public materialIconName = '';

  public accounts: CustomerAccess[] = [];
  public accountsClone: CustomerAccess[] = [];
  public userAccessList: CustomerAccess[] = [];
  public customerID = 0;
  public scrolledToEnd = false;
  public token: any;
  public customer = {} as CustomerLogin;
  public verbiage = {} as LoginVerbiage;
  public searchAccount = '';

  constructor(
    private loginService: LoginService,
    private serverStatusService: ServerStatusService,
    private createAccountService: CreateAccountService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
    private searchService: SearchService,
    private blockUi: BlockUIService) {
    this.loginForm = formBuilder.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });
  }

  ngOnInit() {
    if (this.epicFunction()) {
      this.getIPAddress();
      this.onHandleLoginSubscriptions();
      this.getVerbiage();
      this.buttonStatus = true;
    } else {
      this.buttonStatus = false;
      this.blockUi.stop();
      this.emptyPass = true;
      this.loginError = this.serverStatusService.status(402, 'Your browser is not supported by the site.');
      this.loginForm.reset();
    }
  }

  onHandleLoginSubscriptions() {
    this.loginService.authenticate
      .subscribe((value: boolean) => {
        if (value) {
          this.blockUi.stop();
          this.router.navigateByUrl('/dashboard', { replaceUrl: true });
        }
      });
    // this.createAccountService.getWebsiteAnnouncements()
    //   .subscribe((announcement: string) => this.websiteAnnouncement = announcement);
    this.loginService.accessCustomerList
      .subscribe((value: CustomerAccess[]) => this.userAccessList = value);
  }

  ngOnDestroy() { }

  async signIn() {
    if (!this.credentials['username']) {
      this.emptyUser = true;
    }
    if (!this.credentials['password']) {
      this.emptyPass = true;
    }
    if (!this.emptyUser && !this.emptyPass) {
      this.blockUi.start('Loading...');
      try {
        this.token = await this.loginService.signIn(this.credentials).toPromise();
        this.customer.UserId = this.token.userId;
        this.customer.CustomerNumber = this.token.customernumber;
        if (this.userAccessList.length > 0) {
          this.blockUi.stop();
          this.accounts = this.userAccessList;
          this.accountsClone = this.accounts;
          this.modalMultipleAccounts();
        } else {
          this.blockUi.stop();
          this.router.navigate(['/dashboard']);
        }
        this.RecordAuditSiteLogin('');
      } catch (err) {
        this.blockUi.stop();
        this.emptyPass = true;
        this.loginError = this.serverStatusService.status(err.status, err.error);
        this.loginForm.reset();
      }
    }
    if (this.userAccessList.length === 0) {
      await this.loginService.customerLogin(this.customer);
    }
  }


  cleanLogin(event) {
    const value = event.target.value;
    if (value.length > 0 && event.keyCode !== 13) {
      this.emptyUser = false;
      this.emptyPass = false;
      this.loginError = 'You must add a password.';
    }
  }

  continue() {
    this.router.navigate(['account']);
  }

  modalPass(): void {
    this.forgotPass.showChildModal();
  }

  async sendMail(email: string) {
    this.blockUi.start('Loading...');
    try {
      const response = await this.createAccountService.forgotPassword(email).toPromise();
      this.email_sent = true;
      this.textMessage = response.isFound ? 'Email sent!' : 'Email not found!';
      this.materialIconName = response.isFound ? 'check' : 'clear';
      this.blockUi.stop();
    } catch (err) {
      this.blockUi.stop();
      throw new Error(err);
    }
  }

  resetView(event: boolean) {
    this.email_sent = false;
    this.userEmail = '';
    this.sendEmail.markAsPristine();
  }

  async setCustomerID(customerID: number) {
    this.customerID = customerID;
    if (this.customerID && this.customerID > 0) {
      this.loginService.setAccount(this.customerID).then(() => {
        this.loginService.logInQwikkitOrdering(this.credentials);
      });
      this.multipleAccounts.hideChildModal();
      this.customer.CustomerId = this.customerID;
      this.loginService.customerLogin(this.customer);
    }
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const browser = this.deviceInfo.browser;
    if (browser === 'Chrome' || browser === 'MS-Edge' || browser === 'Firefox' || browser === 'MS-Edge-Chromium' || browser === 'Safari') {
      return true;
    } else {
      return false;
    }
  }

  CalculateLeadgeTotal() {
    if (this.customerLedge !== undefined) {
      for (let i = 0; i < this.customerLedge.length; i++) {
        this.total = this.total + this.customerLedge[i].Remaining_Amt_LCY;
      }
    }
  }

  modalMultipleAccounts(): void {
    this.multipleAccounts.showChildModal();
  }

  openNewTabNewAccount() {
    window.open('https://qwikkit.com/contact-us/', '_blank');
  }

  openTabHomeOwner() {
    window.open('https://bit.ly/3stMusC', '_blank');
  }

  goToURL(url: string) {
    window.open(url, '_blank');
  }

  RecordAuditSiteLogin(ipAddress: string) {
    this.createAccountService.recordSIteAudit(ipAddress).toPromise();
  }

  async getIPAddress() {
    this.createAccountService.recordSIteAuditVisitor().toPromise();
  }

  getVerbiage() {
    this.loginService.getVerbiage().subscribe((verbiage: LoginVerbiage) => {
      this.verbiage = verbiage;
    });
  }

  onSearchAccounts(searchValue: string) {
    this.accounts = this.accountsClone;
    this.accounts = this.searchService.search(this.accounts, searchValue, ['customerNumber']);
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.scrolledToEnd = true;
    }
  }
}
